import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useProfile } from "../context/ProfileContext";

/**
 * Brutalist "fit-tuned" status badge for the navbar.
 *
 * Counts up to 5 fit-signals on the user's linked profile:
 *   front photo, side photo, back photo, 360° video, AI measurements
 *
 * Hidden entirely until the user has at least 1 signal — keeps the badge
 * an earned status symbol rather than a hollow piece of chrome.
 */
const _countFitSignals = (profile) => {
    if (!profile) return 0;
    const c = profile.captures || {};
    return [
        c.front_path,
        c.side_path,
        c.back_path,
        c.video_path,
        profile.ai_measurements,
    ].filter(Boolean).length;
};

export const TrustBadge = () => {
    const { profile } = useProfile();
    const count = _countFitSignals(profile);
    if (count <= 0) return null;
    const full = count >= 5;
    return (
        <Link
            to="/profile"
            data-testid="trust-badge"
            data-count={count}
            aria-label={`Fit-tuned · ${count} of 5 signals captured`}
            title={full
                ? "AI-tuned · all 5 fit signals captured"
                : `Fit-tuned · ${count} of 5 signals captured. Add the rest on /profile.`}
            className="hidden md:inline-flex items-center gap-1 border-2 border-black bg-[#CCFF00] text-black px-2 py-1.5 font-mono text-[10px] uppercase tracking-widest shadow-brutal-sm btn-press"
        >
            <ShieldCheck className="w-3.5 h-3.5" />
            <span className="font-bold" data-testid="trust-badge-count">
                {full ? "AI-TUNED" : `FITS ${count}/5`}
            </span>
            {full && <span className="text-[#FF00FF]">✓</span>}
        </Link>
    );
};
